import { Avatar, Button, Typography } from '@mui/material';
import { useIsDesktop } from 'Hooks';
import { PlusBtn } from 'Images';
import { FC } from 'react';

interface IDocumentTypeButton {
  label: string;
  onClick: () => void;
  isFirstType?: boolean;
}

export const DocumentTypeButton: FC<IDocumentTypeButton> = ({
  label,
  onClick,
  isFirstType,
}) => {
  const isDesktop = useIsDesktop();
  return (
    <Button
      onClick={onClick}
      sx={{
        width: 'fit-content',
        height: '40px',
        borderRadius: '48px',
        border: '1px solid',
        borderColor: 'primary.shade_200',
        backgroundColor: isFirstType ? '#F6F8FE' : 'white',
        p: isDesktop
          ? isFirstType
            ? '8px 16px'
            : '6px 16px'
          : isFirstType
          ? '7px 12px'
          : '5px 12px',
        display: 'flex',
        gap: '6px',
      }}
    >
      <Avatar
        alt=''
        src={PlusBtn}
        sx={{
          width: '14px',
          height: '14px',
        }}
      />
      <Typography
        variant='body6'
        sx={{
          color: '#1552E8',
        }}
      >
        {label}
      </Typography>
    </Button>
  );
};
